<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Dirección',
          text: 'POL.IND.DE CROSS, EDIFICIO 4 NAVE 6 39600 MALIAÑO (CANTABRIA) España',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Teléfono',
          text: '942 26 96 44',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'cantdelimar@cantdelimar.es',
        },
      ],
    }),
  }
</script>
